import React, {useEffect, useState} from "react";
import "./style.css";
import { FloatingContinueBtn } from "../../../../components/FloatingContinueBtn";

export const Age = ({clickNext, data, clicked, setAllow, isCurPage, onPageFocus, onPageKeyDown, logEvent, inputRef}) => {
  const [age, setAge] = useState(data.age);
  const [ageLimit, setAgeLimit] = useState(false);
  
  // 控制浮动按钮显示
  const [showFloatingBtn, setShowFloatingBtn] = useState(false);
  
  // 验证并限制年龄范围（只限制最大值，最小值在blur时处理）
  const validateAge = (value) => {
    if (value === '') return '';
    const num = parseInt(value);
    if (isNaN(num)) return '';
    // 只限制最大值
    if (num > 140) return '140';
    return value;
  };
  
  // 处理输入变化
  const handleAgeChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, '');
    const validated = validateAge(value);
    setAge(validated);
  };
  
  // 处理失去焦点：自动修正到最小值
  const handleAgeBlur = () => {
    setTimeout(() => {
      setShowFloatingBtn(false);
    }, 200);
    
    if (age !== '') {
      const num = parseInt(age);
      if (!isNaN(num) && num < 16) {
        setAge('16');
      }
    }
  };

  useEffect(() => {
    if (clicked) {

      logEvent("surveylandingitem_click", {
        value: age,
      }, "survey");
      const ageNumber = parseInt(age);
      if (!Number.isNaN(ageNumber) && ageNumber >= 16 && ageNumber <= 140) {
        clickNext(age)
      }
    }
  }, [clicked]);

  useEffect(() => {
    if (age !== undefined && age !== null && age !== "") {
      const ageNumber = parseInt(age);
      const valid = !Number.isNaN(ageNumber) && ageNumber >= 16 && ageNumber <= 140;
      setAgeLimit(!valid);
      setAllow(valid);
    } else {
      setAllow(false);
      setAgeLimit(false);
    }

  }, [age]);
  
  // 处理输入框聚焦
  const handleFocus = (e) => {
    setShowFloatingBtn(true);
    if (onPageFocus) onPageFocus(e);
  };
  
  // 处理输入框失焦
  const handleBlur = () => {
    handleAgeBlur();
  };
  
  // 处理浮动按钮点击
  const handleFloatingBtnClick = () => {
    const ageNumber = parseInt(age);
    if (!Number.isNaN(ageNumber) && ageNumber >= 16 && ageNumber <= 140) {
      // 隐藏键盘
      if (inputRef.current) inputRef.current.blur();
      setShowFloatingBtn(false);
      
      logEvent("surveylandingitem_click", {
        value: age,
      }, "survey");
      
      // 触发提交
      clickNext(age);
    }
  };


  return (
    <div className="age" data-model-id="16755:1153">
      <FloatingContinueBtn 
        show={showFloatingBtn} 
        allow={age !== undefined && age !== null && age !== "" && 
               !Number.isNaN(parseInt(age)) && parseInt(age) >= 16 && parseInt(age) <= 140}
        onClick={handleFloatingBtnClick}
      />
      <div className="frame-4">
        <div className="title">
          <div className="heading">What's your age?</div>
        </div>

        <div className="age-container-wrapper">
          <div className="age-container">

            <input
                ref={inputRef}
                readOnly={!isCurPage}
                enterKeyHint="done"
                className="height-label"
                value={age} 
                placeholder={"Age"}
                onChange={handleAgeChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={onPageKeyDown} 
                type={"number"} 
                inputMode={"numeric"} />
          </div>
        </div>
        <div>
          {ageLimit && <div className={"age-warning"}>
            It's best to wait until you're 16 or older to use it.
          </div>}
          <div className="info-container">
            <div className="info-row">
              <p className="info-text">
                This can help us modify your personal plan
              </p>

              <p className="info-description">
                Elderly tend to have more body fat than younger people with the same BMI.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
